import { uniq } from 'es-toolkit';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { webSessionStorage } from '../lib/webSessionStorage';

type OpenGroups = Record<string, boolean>;

export interface MenuPrefsState {
  favorites: string[];
  openGroups: OpenGroups;
  sidebarCollapsed: boolean;
  toggleFavorite: (key: string) => void;
  setFavorites: (keys: string[]) => void;
  setGroupOpen: (key: string, open: boolean) => void;
  toggleGroup: (key: string) => void;
  expandAll: (groupKeys: string[]) => void;
  collapseAll: (groupKeys: string[]) => void;
  setSidebarCollapsed: (collapsed: boolean) => void;
}

export const useMenuPrefsStore = create<MenuPrefsState>()(
  persist(
    (set, get) => ({
      favorites: [],
      openGroups: {},
      sidebarCollapsed: false,
      toggleFavorite: (key) => {
        const current = get().favorites;
        const next = current.includes(key) ? current.filter((k) => k !== key) : [...current, key];
        set({ favorites: next });
      },
      setFavorites: (keys) => set({ favorites: uniq(keys) }),
      setGroupOpen: (key, open) => set({ openGroups: { ...get().openGroups, [key]: open } }),
      toggleGroup: (key) => {
        const current = get().openGroups[key] ?? false;
        set({ openGroups: { ...get().openGroups, [key]: !current } });
      },
      expandAll: (groupKeys) => {
        const map: OpenGroups = { ...get().openGroups };
        groupKeys.forEach((k) => (map[k] = true));
        set({ openGroups: map });
      },
      collapseAll: (groupKeys) => {
        const map: OpenGroups = { ...get().openGroups };
        groupKeys.forEach((k) => (map[k] = false));
        set({ openGroups: map });
      },
      setSidebarCollapsed: (collapsed) => set({ sidebarCollapsed: collapsed }),
    }),
    {
      name: 'menu_prefs_v2',
      storage: webSessionStorage,
      partialize: (state) => ({
        favorites: state.favorites,
        openGroups: state.openGroups,
        sidebarCollapsed: state.sidebarCollapsed,
      }),
    },
  ),
);
